import { useEffect, useState }             from "react"
import { Button, FormControl, FormLabel, Link, TextField } from "@mui/material"
import { useNavigate }                       from "react-router"
import { AuthCard }                          from "./AuthCard"
import { useGlobalConfig }                   from "context/GlobalContext"
import { useToast }                          from "context/ToastContext"
import { AuthApis }                          from "apis/authAPI"
import { ANALYTICS_EVENTS }                  from "framework/analytics/AnalyticsEvents"

export const ForgotPasswordComponent = () => {

  const { rc }   = useGlobalConfig()
  const toast    = useToast()
  const navigate = useNavigate()

  const [email, setEmail]     = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (rc.session.isUserLoggedIn()) {
      rc.uiRouter.navigateToHome()
    }
  })

  useEffect(() => {
    rc.analytics.trackEvent(ANALYTICS_EVENTS.AUTH.FORGOT_PASSWORD_OPENED)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = async (event : React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!email.trim()) {
      toast.error('Please enter your email')
      return
    }

    rc.analytics.trackEvent(ANALYTICS_EVENTS.AUTH.FORGOT_PASSWORD_SUBMITTED)
    setLoading(true)

    const resp = await AuthApis.forgotPassword(rc, email.trim())

    setLoading(false)

    if (resp.error) {
      rc.analytics.trackEvent(ANALYTICS_EVENTS.AUTH.FORGOT_PASSWORD_FAILED, {
        error_message : resp.error.message || 'forgot_password_failed',
      })
      toast.error(resp.error.message || 'Could not send reset link. Please try again.')
      return
    }

    rc.analytics.trackEvent(ANALYTICS_EVENTS.AUTH.FORGOT_PASSWORD_SUCCESS)
    // Backend intentionally returns ok:true even if the email is unknown — do not leak existence.
    toast.success('If an account exists for that email, a reset link has been sent.')
    // Move off the form (prevents resubmission spam) to the reset page, where the
    // user can paste the code from the email if the deep link is unavailable.
    navigate('/auth/reset-password', { state: { email : email.trim() } })
    setEmail('')
  }

  return (
    <AuthCard title="Forgot Password">
      <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <FormControl>
          <FormLabel sx={{ textAlign: 'left' }} htmlFor="email">Email</FormLabel>
          <TextField
            id="email"
            name="email"
            type="email"
            placeholder="Enter your email"
            autoFocus
            required
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>
        <Button type="submit" fullWidth variant="contained" loading={loading}>
          Send reset link
        </Button>
        <Link
          component="button"
          type="button"
          onClick={() => navigate('/auth/login')}
          sx={{ fontSize: '0.875rem', cursor: 'pointer' }}
        >
          Back to login
        </Link>
      </form>
    </AuthCard>
  )
}
